import {
  ApolloClient,
  NormalizedCacheObject, InMemoryCache,
  createHttpLink,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import typePolicies from './typePolicies'

let apolloClientSingleton: ApolloClient<NormalizedCacheObject>;

export type ApolloClientOpts = {
  getUri: () => string
  getCurrentAccessToken: () => string | undefined
};

const genHttpLink = (getUri: ApolloClientOpts['getUri']) => createHttpLink({
  uri: getUri(),
  fetchOptions: {
    mode: 'cors',
  },
});

const genAuthLink = (getCurrentAccessToken: ApolloClientOpts['getCurrentAccessToken']) =>
  setContext((_, { headers }) => {
    const token = getCurrentAccessToken();
    return {
      token,
      headers: {
        ...headers,
        ...(token ? {
          Authorization: token, // TODO change to `Bearer ${token}` after BE ready
        } : {})
      },
    };
  });

const createApolloClient = ({
  getUri,
  getCurrentAccessToken,
}: ApolloClientOpts) => {
  return new ApolloClient({
    link: genAuthLink(getCurrentAccessToken).concat(genHttpLink(getUri)),
    cache: new InMemoryCache({
      typePolicies,
    }),
    connectToDevTools: process.env.REACT_APP_RELEASE_STAGE !== "production",
  });
};

export const initApolloClientSingleton = (opts: ApolloClientOpts) =>
  (apolloClientSingleton = createApolloClient(opts));

export const getApolloClientSingleton = () => apolloClientSingleton;

export const initOrGetApolloClientSingleton = (opts: ApolloClientOpts) => {
  if (!apolloClientSingleton) {
    return initApolloClientSingleton(opts)
  }
  return apolloClientSingleton;
};
